export default "__VITE_ASSET__BGKATGIE__"